<script setup>
const route = useRoute()
const config = useRuntimeConfig()
const loading = ref(false)
const { Settings } = useSettings()

const blobId = Number(route.params.id)
const { data: blob } = await useFetch(`/api/blob/${blobId}`)

const instanceName = Settings?.value?.name || 'Blob'
const pageTitle = `${instanceName} - ${blob?.value?.name ?? ''}`
useHead({
  title: pageTitle,
  meta: [
    { property: 'og:title', content: pageTitle },
    // { property: 'og:description', content: blob?.value?.description ?? '' },
    { property: 'og:url', content: config.public.baseUrl + `/b/${blobId}` },
    { property: 'og:image', content: config.public.baseUrl + '/media/logo' }
  ],

  link: [{ rel: 'alternate', type: 'application/rss+xml', title: Settings?.value?.name || 'Blob', href: `/feed/${blobId}` }]
})

</script>

<template>
<section class="blobs_blob">
  <Blobs />

  <BlobInfo :blobId='blobId' />
   <AutoPostList :api="`/api/post/${blobId}`"
    :pluralistic="blob.pluralistic" />
   
</section>
</template>

<style>
.blobInfo .v-list-item:nth-child(odd) {
  background-color: #f3f3f3;
}
</style>
